export const DEFAULT_LEAVE_DELAY = 100;
